exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.limits-manager__select, .limits-manager__table {\n  margin: 24px 0;\n}\n@media only screen and (max-width: 1023px) {\n.limits-manager__select, .limits-manager__table {\n      margin: 16px 0;\n}\n}\n.limits-manager__table-row {\n  border: none !important;\n}\n.limits-manager__table-row:hover .md-table-cell {\n    background: none !important;\n}\n.limits-manager__table-row:first-child .md-table-head-container,\n  .limits-manager__table-row:last-child .md-table-cell-container {\n    margin-top: 16px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-83ab7524","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/limits/Limits.Manager.vue
// module id = St+H
// module chunks = 1